import { api } from 'app/config/apiConfig';

export const deleteZoneApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteZone: builder.mutation<{ success: boolean }, { warehouseId: string; zoneId: string }>({
      query: ({ warehouseId, zoneId }) => ({
        url: `/warehouses/${warehouseId}/zones/${zoneId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Zones'],
    }),
  }),
});

export const { useDeleteZoneMutation } = deleteZoneApi;
